import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { INavigationItem } from '@nrwl/navigation-abstract';

@Injectable({
  providedIn: 'root'
})
export class BreadCrumbService {
  readonly breadCrumbs$: BehaviorSubject<Array<INavigationItem>> = new BehaviorSubject([]);

  setBreadCrumbs(value: Array<INavigationItem>) {
    this.breadCrumbs$.next(value);
  }
}
